<template>
  <tg-layout :headerHeight="headerHeight">
    <template slot="header">
      <el-row type="flex" justify="space-between">
        <tg-search-tool @on-submit="handleSearch">
          <tg-date-search
            ref="dateSearch"
            size="small"
            v-model="dateRange"
            showDateRangePicker
            showTomorrow
            twoMonthLimit
          ></tg-date-search>
          <template slot="right"></template>
        </tg-search-tool>
        <el-row type="flex" v-show="hasData">
          <tg-button
            round
            border
            hoverBorderOnly
            theme="info"
            @click.native="handleExport"
          >
            <template slot="icon" slot-scope="scope">
              <i
                class="tg-icon tg-icon-export"
                :class="{ active: scope.isHover }"
              ></i>
            </template>
            {{ $t("component.btn.export") }}
          </tg-button>
        </el-row>
      </el-row>
      <el-row style="padding: 5px">
        <!-- 平台選擇按鈕 -->
        <ThirdPartySearchBtn
          :style="{ display: showThirdParty ? 'initial' : 'none' }"
          @click.native="showThirdPartyCheckBoxDialog"
        ></ThirdPartySearchBtn>
        <ThirdPartyPlatform
          :style="{ display: showThirdParty ? 'initial' : 'none' }"
          v-model="thirdPartyData"
          @on-change="handleSearchThirdParty"
        ></ThirdPartyPlatform>
      </el-row>
      <el-row style="padding: 5px">
        <!-- 玩法選擇按鈕 -->
        <ThirdPartySearchBtn
          :style="{ display: showMarketTypeFilter ? 'initial' : 'none' }"
          :text="$t('component.btn.marketType_choose')"
          @click.native="showMarketTypeFilterDialog"
        ></ThirdPartySearchBtn>
        <ThirdPartyPlatform
          :style="{ display: showMarketTypeFilter ? 'initial' : 'none' }"
          v-model="marketTypeItems"
          @on-change="handleMarketTypeItemsChange"
        ></ThirdPartyPlatform>
      </el-row>
    </template>

    <!-- 平台篩選彈窗 -->
    <ThirdPartyCheckBoxDialog
      ref="thirdPartyCheckBoxDialog"
      :third_party="thirdPartyData"
      @on-click="handleSearchThirdParty"
    ></ThirdPartyCheckBoxDialog>

    <!-- 玩法篩選彈窗 -->
    <MarketTypeFilterDialog
      ref="marketTypeFilterDialog"
      :marketTypeFilter="marketTypeFilter"
      @on-click="handleSearchMarketType"
    ></MarketTypeFilterDialog>
    <tg-table
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      @on-loaded="handleLoaded"
      showSummary
      :summary-method="parsePageSummary"
      showPagination
    >
    </tg-table>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgDateSearch from "@/components/datePicker/TgDateSearch";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgButton from "@/components/button/TgButton";
import ThirdPartySearchBtn from "@/components/button/ThirdPartySearchBtn";
import ThirdPartyPlatform from "@/components/tool/ThirdPartyPlatform";
import ThirdPartyCheckBoxDialog from "@/components/dialog/ThirdPartyCheckBoxDialog";
import MarketTypeFilterDialog from "@/components/dialog/MarketTypeFilterDialog";

import { convertToRows, flatColumns } from "@/utils/table";
import { summary } from "@/utils/table";
import xlsx from "@/utils/xlsx";

import apis from "@/apis";

const api = apis.accounts.high_profit_members;
const STORE_UPDATE = "pages/accounts/history/update";
const STORE_UPDATE_SEARCH = "pages/accounts/history/update_search";

export default {
  components: {
    TgLayout,
    TgDateSearch,
    TgSearchTool,
    TgButton,
    ThirdPartySearchBtn,
    ThirdPartyPlatform,
    ThirdPartyCheckBoxDialog,
    MarketTypeFilterDialog,
  },
  data() {
    return {
      columns: [],
      amountColumns: [],
      proxy: api.getData,
      dateRange: {},
      group: [80, 70, 60, 40, 20, 10], // 帳號層級
      dropdown: [],
      showAmount: false,
      hasData: false,
      amountTotalData: [],
      amountPageData: [],
      showThirdPartyCheckBoxDialog: false,
      showMarketTypeFilter: true,
      marketTypeFilter: [1, 2, 3, 0, 6, "-1"],
    };
  },
  watch: {
    marketTypeFilter(val) {
      this.market_type = val.filter((x) => x != -1);
    },
  },
  computed: {
    headerHeight() {
      return !this.showAmount ? 120 : 160;
    },
    request() {
      return { ...this.searchData, ...this.dateRange };
    },
    dateString() {
      return new Date().toISOString().replace(/[-:.]/g, "");
    },
    parsePageSummary() {
      let data = this.amountPageData ? [this.amountPageData] : [];

      return () => {
        return summary(
          this.columns,
          data,
          this.$t("component.table.summary"),
          0
        );
      };
    },
    store() {
      return this.$store.state.pages.accounts.history;
    },
    thirdPartyData: {
      get() {
        return this.store.thirdPartyData;
      },
      set(val) {
        this.$store.commit(STORE_UPDATE, { thirdPartyData: val });
      },
    },
    marketTypeItems() {
      return this.marketTypeFilter.map((item) => {
        return {
          key: item,
          text:
            item == "-1"
              ? this.$t("label.other_third_party")
              : this.$t("enum.marketType[" + item + "]"),
        };
      });
    },
    searchData: {
      get() {
        return this.store.searchData;
      },
      set(val) {
        this.$store.commit(STORE_UPDATE_SEARCH, val);
      },
    },
  },
  created() {
    if (this.$route.params.invoke == "menu") {
      this.initRequest();
    }

    this.group.forEach((content) => {
      this.dropdown.push({
        label: this.$t("column.l" + content),
        value: content,
      });
    });

    api.getColumns().then((response) => {
      this.columns = response.data.columns;
    });

    this.$nextTick(() => {
      this.$refs.table.init(this.request);
    });
  },
  methods: {
    initRequest() {
      this.targetName = "";
      let thirdPartyData = [
        { platform: "tg", category: 0 },
        ...this.thirdParties,
      ];
      let platforms = thirdPartyData.map((x) => x.platform);
      this.thirdPartyData = thirdPartyData;
      this.platforms = platforms;
      this.clickedUser = null;
      this.groupLine = "";
      this.$store.commit("breadcrumb/clear");
    },
    handleSearchThirdParty(value) {
      this.thirdPartyData = value;
      this.platforms = this.thirdPartyData.map((r) => {
        return r.platform;
      });

      if (this.prepared) {
        this.$nextTick(() => {
          let request = { ...this.request };
          if (this.clickedUser) {
            request.targetName = this.clickedUser;
          }
          this.$refs.table.search(request);
        });
      }
    },
    handleSearchMarketType(values) {
      this.marketTypeFilter = [...values];
      let request = { ...this.request };
      // 不查三方
      if (values.indexOf("-1") == -1) {
        request.third_party = ["tg"];
      } else {
        if (values.length == 1) {
          request.third_party = request.third_party.filter((x) => x != "tg");
        }
      }
      request.market_type = values.filter((x) => x != -1);

      this.$refs.table.search(request);
    },
    showMarketTypeFilterDialog() {
      this.$refs.marketTypeFilterDialog.showDialog();
    },
    handleMarketTypeItemsChange(items) {
      let marketTypes = (this.marketTypeFilter = items.map((x) => x.key));
      this.handleSearchMarketType(marketTypes);
    },
    // 查詢
    handleSearch() {
      this.$nextTick(() => {
        this.$refs.table.search(this.request);
      });
    },
    // 處理response
    handleLoaded(response) {
      if (response.retcode == 0) {
        this.hasData = response.data.length > 0;
        this.showAmount = response.data.length > 0;

        let columns = JSON.parse(JSON.stringify(this.columns));

        this.columns = columns;

        this.amountTotalData = response.amount_total;
        this.amountPageData = response.amount_page;
      }
    },
    handleExport() {
      let exportFileName = this.$t("component.export.return_bonus_statement");
      let request = { ...this.request, isExport: true };
      api.getExport(request).then((response) => {
        let data = response.data;
        let headerRow = convertToRows(response.columns);
        let columns = flatColumns(response.columns);
        let ws = xlsx.makeSheet(
          headerRow,
          columns,
          data,
          response.amount_total
        );
        xlsx.exportExcel(ws, exportFileName + "-" + this.dateString);
      });

      this.$store.commit("breadcrumb/add", {
        name: this.$route.name,
        id: this.$route.name + "_" + this.row.name,
        meta: {
          title: this.row.name,
        },
      });
    },
  },
};
</script>
